import { useCallback, useRef } from 'react';
import { createEffectHandler } from '../effects';
import { Meta } from '../types';
import { FormInstance } from 'antd';

export const useEffects = (meta: Meta, form: FormInstance) => {
  const processingRef = useRef(false);
  const batchUpdateRef = useRef<Record<string, any>>({});

  const handleEffects = useCallback(
    (changedValues: Record<string, any>, allValues: Record<string, any>) => {
      const effectHandler = createEffectHandler({
        meta,
        form,
        processingRef,
        batchUpdateRef
      });
      
      effectHandler(changedValues, allValues);
    },
    [meta, form]
  );

  return {
    handleEffects,
    processingRef,
    batchUpdateRef
  };
};